import api from "../api";
import {iniciarRequisicao, logout} from "@/helpers";
import {STATUS_HTTP} from "../statusHTTP";

const PREFIXO = 'diagnostico';

export const buscarAnaliseCruzadaPorCurvas = async (params) => {
  const url = `/${PREFIXO}/analise-curvas-cruzadas/curvas`;
  const { data, status } = await api.post(url, params, { headers: iniciarRequisicao() }).catch(logout);

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data.analise;
}

export const buscarAnaliseCruzadaPorCurvaPopularidade = async (params) => {
  const url = `/${PREFIXO}/analise-curvas-cruzadas/curvas-popularidade`;
  const {data, status} = await api.get(url, {params, headers: iniciarRequisicao()}).catch(logout);

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data.analise;
}

export const buscarAnaliseCruzadaPorCurvaCriticidade = async (params) => {
  const url = `/${PREFIXO}/analise-curvas-cruzadas/curvas-criticidade`;
  const {data, status} = await api.get(url, {params, headers: iniciarRequisicao()}).catch(logout);

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data.analise;
}

export const buscarAnaliseCruzadaPorSegmento = async (params) => {
  const url = `/${PREFIXO}/analise-curvas-cruzadas/segmentos`;
  const {data, status} = await api.get(url, {params, headers: iniciarRequisicao()}).catch(logout);

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data.analise;
}

export const buscarAnaliseCruzadaPorFornecedores = async (params) => {
  const url = `/${PREFIXO}/analise-curvas-cruzadas/fornecedores`;
  const {data, status} = await api.get(url, {params, headers: iniciarRequisicao()}).catch(logout);

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data.analise;
}

export const buscarAnaliseCruzadaPorProduto = async (params) => {
  const url = `/${PREFIXO}/analise-curvas-cruzadas/produtos`;
  const {data, status} = await api.get(url, {params, headers: iniciarRequisicao()}).catch(logout);

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data.analise;
}

export const buscarParametrizacaoCoberturasPorCurvas = async (params) => {
  const url = `/${PREFIXO}/coberturas-curvas`;
  const {data, status} = await api.get(url, {params, headers: iniciarRequisicao()}).catch(logout);

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data.coberturas;
}

export const atualizarParametrizacaoCoberturasPorCurvas = async (params) => {
  const url = `/${PREFIXO}/coberturas-curvas`;
  const {data, status} = await api.post(url, params, {headers: iniciarRequisicao()}).catch(logout);

  if (status !== STATUS_HTTP.CREATED) {
    logout();
  }

  localStorage.token = data.token;
  return true;
}

export const buscarDetalhamentoProdutos = async (params) => {
  const url = `/${PREFIXO}/detalhamento/produtos`;
  const {data, status} = await api.get(url, {params, headers: iniciarRequisicao()}).catch(logout);

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data.produtos;
}

export const agendarAplicacaoCoberturasCurvas = async (params) => {
  const url = `/${PREFIXO}/coberturas-curvas/agendar-aplicacao`;
  const {data, status} = await api.post(url, params, {headers: iniciarRequisicao()}).catch(logout);

  if (status !== STATUS_HTTP.CREATED) {
    logout();
  }

  localStorage.token = data.token;
  return true;
}

export const buscarExistenciaDeCoberturasAgendadas = async () => {
  const url = `/${PREFIXO}/coberturas-curvas/aplicar-coberturas-agendado`;
  const {data, status} = await api.get(url, {headers: iniciarRequisicao()}).catch(logout);

  if (status !== STATUS_HTTP.CREATED) {
    logout();
  }

  localStorage.token = data.token;
  return data.agendado;
}

export const buscarDatasDiagnostico = async () => {
  const url = `/${PREFIXO}/datas`;
  const {data, status} = await api.get(url, {headers: iniciarRequisicao()}).catch(logout);

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data.datas;
}

export const buscarIndicadorEvolucao = async (params) => {
  const url = `/${PREFIXO}/analise-curvas-cruzadas/indicadores/evolucao-estoque`;
  const { data, status } = await api.post(url, params, { headers: iniciarRequisicao() }).catch(logout);

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data;
}

export const buscarPermissaoParametrizacaoDiagnostico = async () => {
  const url = `/${PREFIXO}/coberturas-curvas/permissao`;
  const {data, status} = await api.get(url, {headers: iniciarRequisicao()}).catch(logout);

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data.ativar_parametrizacao_diagnostico;
}
